import { render, staticRenderFns } from "./PayslipDetailsView.vue?vue&type=template&id=327d6d54&"
import script from "./PayslipDetailsView.vue?vue&type=script&lang=js&"
export * from "./PayslipDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./PayslipDetailsView.vue?vue&type=style&index=0&id=327d6d54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports